/**
 * Zero-config export for Vibeship DevTools
 * 
 * Usage:
 * ```tsx
 * import { VibeshipDevTools } from '@vibeship/devtools/zero';
 * 
 * export default function Layout({ children }) {
 *   return (
 *     <body>
 *       {children}
 *       <VibeshipDevTools />
 *     </body>
 *   );
 * }
 * ```
 */

// Export main components
export { VibeshipDevTools, VibeshipDevToolsPanel } from './VibeshipDevTools';
export type { VibeshipDevToolsProps, VibeshipDevToolsPanelProps } from './VibeshipDevTools';

// Export hooks for custom implementations
export { useClientSideScan, useFeatureDetection, useProgressiveLevel } from './hooks';
export type { UseClientSideScanOptions } from './hooks';

// Export scanner utilities
export { scanForTasks, scanDomContent, scanNextJsProps, scanTextContent, watchForChanges } from './scanner';
export type { ClientTask, ScanOptions } from './scanner';

// Export UI components for custom implementations
export { TaskPanel } from './components/TaskPanel';
export type { TaskPanelProps } from './components/TaskPanel';

export { UpgradePrompt, UpgradeBanner } from './components/UpgradePrompt';
export type { UpgradePromptProps, UpgradeBannerProps, UpgradeLevel } from './components/UpgradePrompt';

export { VirtualList, useVirtualListDynamicHeights } from './components/VirtualList';
export type { VirtualListProps } from './components/VirtualList';

export { ErrorBoundary, withErrorBoundary, useErrorHandler, AsyncErrorHandler } from './components/ErrorBoundary';
export type { ErrorBoundaryProps, ErrorBoundaryState } from './components/ErrorBoundary';